import "./ScoodleAccountTile.less";

import React, { Component } from "react";
import { translate } from "react-i18next";

import scoodleIcon from "../../assets/images/scoodle_icon_colour.svg";

class ScoodleAccountTile extends Component {
	render() {
		const { email, t } = this.props;

		return (
			<button className="secondarybtn scoodle-account-tile" disabled>
				<img src={scoodleIcon} />
				<div className="account">
					<h2>{t("scoodleAccount")}</h2>
					<p>{email}</p>
				</div>
			</button>
		);
	}
}
export default translate("scoodleAccountTile")(ScoodleAccountTile);



// WEBPACK FOOTER //
// ./src/components/ScoodleAccountTile/ScoodleAccountTile.js